function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import * as React from 'react';
import { Image, MediaPlayer, PDFReader } from '@uncinc/uncinc-react-kitchen-sink';
import config from 'react-global-configuration';
import parseEmbedUrl from '../../helpers/parseEmbedUrl';

/**
 * These 3 types below are used as parameters for the MediaReferenceField type.
 */

var DynamicMediaItem = function DynamicMediaItem(props) {
  var media = props.media,
    _props$imageAspectRat = props.imageAspectRatio,
    imageAspectRatio = _props$imageAspectRat === void 0 ? 'original' : _props$imageAspectRat,
    className = props.className,
    caption = props.caption,
    _props$posterImage = props.posterImage,
    posterImage = _props$posterImage === void 0 ? '' : _props$posterImage,
    _props$alt = props.alt,
    alt = _props$alt === void 0 ? '' : _props$alt,
    _props$aboveTheFold = props.aboveTheFold,
    aboveTheFold = _props$aboveTheFold === void 0 ? false : _props$aboveTheFold;
  var SCREEN_XS = config.get('SCREEN_XS') || 0;
  var SCREEN_SM = config.get('SCREEN_SM') || 576;
  var SCREEN_MD = config.get('SCREEN_MD') || 768;
  var SCREEN_LG = config.get('SCREEN_LG') || 1200;
  var SCREEN_XL = config.get('SCREEN_XL') || 1560;
  switch (media.bundle) {
    case 'svg':
      {
        return /*#__PURE__*/React.createElement("img", {
          className: className,
          src: media.source,
          alt: caption
        });
      }
    case 'document':
      {
        return /*#__PURE__*/React.createElement(PDFReader
        // When developing locally, there's a fair chance you'll run into CORS errors
        // You can then use this url, for example:
        // url="https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK"
        , {
          url: media.source
        });
      }
    case 'audio':
    case 'remote_video':
    case 'video':
      {
        var mimeType;
        if (media.bundle === 'remote_video') {
          mimeType = parseEmbedUrl(media.embed).mime;
        } else {
          mimeType = media.mime_type;
        }
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaPlayer, {
          posterUrl: posterImage,
          src: media.bundle === 'remote_video' ? media.embed : media.source,
          type: mimeType
        }), caption && /*#__PURE__*/React.createElement("p", {
          className: "caption pt-3 mb-0"
        }, caption));
      }
    case 'image':
      {
        var breakpoints = ['xs', 'sm', 'md', 'xl'];
        var src;
        if (aboveTheFold) {
          // For images above the fold, adaptive gives poor LCP score,
          // so fall back to a Picture component instead.
          var sizes = {
            xs: SCREEN_XS,
            sm: SCREEN_SM,
            md: SCREEN_MD,
            xl: SCREEN_LG // TODO: https://uncinc.monday.com/boards/456111162/pulses/6549613174
          };

          src = breakpoints.reduce(function (accumulator, breakpoint) {
            var _media$styles;
            var imageStyle = (_media$styles = media.styles) === null || _media$styles === void 0 ? void 0 : _media$styles["ratio_".concat(imageAspectRatio, "_").concat(breakpoint)];

            // @ts-ignore
            accumulator[sizes[breakpoint]] = "".concat(imageStyle || media.source);
            return accumulator;
          }, {});
        } else {
          src = breakpoints.map(function (breakpoint) {
            var _media$styles2;
            var imageStyle = (_media$styles2 = media.styles) === null || _media$styles2 === void 0 ? void 0 : _media$styles2["ratio_".concat(imageAspectRatio, "_").concat(breakpoint)];
            return "".concat(imageStyle || media.source);
          });
        }

        // The AdaptivePicture picture component needs a number as a ratio.
        var ratio;
        var _imageAspectRatio$spl = imageAspectRatio.split('_'),
          _imageAspectRatio$spl2 = _slicedToArray(_imageAspectRatio$spl, 2),
          antecedent = _imageAspectRatio$spl2[0],
          consequent = _imageAspectRatio$spl2[1];
        if (antecedent && consequent) {
          ratio = parseInt(antecedent, 10) / parseInt(consequent, 10);
        }
        return /*#__PURE__*/React.createElement("div", {
          className: className
        }, /*#__PURE__*/React.createElement(Image, {
          src: src,
          alt: alt || media.alt || media.title || caption,
          lazyload: false,
          aspectRatio: ratio
        }), caption && /*#__PURE__*/React.createElement("p", {
          className: "caption"
        }, caption));
      }
    default:
      return null;
  }
};
export default DynamicMediaItem;